import {Button, CardBody, Col, Spinner} from "reactstrap";
import {ArrowLeft, ArrowRight} from "react-feather";
import React, {Fragment, useEffect, useState} from "react";

export function fixFooterButtons() {
    let footerButtons = document.querySelector('#footer-buttons');
    if (footerButtons == null) {
        return;
    }
    let sibling = footerButtons.previousElementSibling;
    if (sibling == null) {
        return;
    }
    let footer = window.scrollY + footerButtons.getBoundingClientRect().top;
    let body = window.scrollY + sibling.getBoundingClientRect().bottom;
    if (body >= footer) {
        document.getElementById("footer-buttons").style.position = "static";
    }
}

const FooterButtons = (props) => {
    let steps = props.steps;
    if (!steps) {
        steps = 3;
    }

    useEffect(() => {
        if (props.forceStaticPosition) {
            document.getElementById("footer-buttons").style.position = "static";
        } else {
            setTimeout(() => {
                fixFooterButtons();
                setTimeout(() => {
                    fixFooterButtons();
                }, 1000);
            }, 100);
        }
    }, [])

    return (
        <div id={"footer-buttons"} style={{
            position: "absolute",
            paddingBottom: "25px",
            marginTop: "15px",
            marginRight: props.marginRight ? props.marginRight : "0px",
            paddingTop: "15px",
            bottom: "10px",
            width: "100%"
        }}
             className='d-flex justify-content-between'>
            <div className={"row"} style={{width: "100%"}}>
                <Col>
                    {props.backClick &&
                    <Button.Ripple style={{marginLeft: "15px"}} onClick={props.backClick}
                                   color='secondary' className='btn-prev' outline>
                        <ArrowLeft size={14} className='align-middle mr-sm-25 mr-0'></ArrowLeft>
                        <span className='align-middle d-sm-inline-block d-none'>Nazad</span>
                    </Button.Ripple>
                    }
                </Col>

                {props.step &&
                <Col
                    className="text-center justify-content-center align-content-center align-items-center my-auto">
                    {props.step}/{steps}
                </Col>
                }
                {props.forwardClick && !props.loading &&
                <Col className="float-right text-right" style={{marginRight: "25px"}}>
                    {props.draftClick &&
                    <Button.Ripple style={{marginRight: "25px"}} onClick={props.draftClick} type='submit'
                                   color='primary' className='btn-next'>
                        <span className='align-middle d-sm-inline-block d-none'>Spremi draft</span>
                    </Button.Ripple>
                    }
                    <Button.Ripple

                        onClick={props.forwardClick} type='submit' color='primary' className='btn-next'>
                        {props.forwardLabel &&
                        <span>{props.forwardLabel}</span>
                        }
                        {!props.forwardLabel &&
                        <Fragment>
                            <span className='align-middle d-sm-inline-block d-none'>Sljedeće</span>
                            <ArrowRight size={14} className='align-middle ml-sm-25 ml-0'></ArrowRight>
                        </Fragment>
                        }
                    </Button.Ripple>
                </Col>
                }
                {props.loading &&
                <Col className="float-right text-right" style={{marginRight: "25px"}}>
                    <Spinner/>
                </Col>
                }
            </div>
        </div>
    );
}

export default FooterButtons;